// extracted by mini-css-extract-plugin
export default {"container":"PaymentMethod_container__t-50e"};